// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__38ni4","search":"Layout_search__RhDFb","mobile":"Layout_mobile__L2Elv"};